export default class SmsNotification {
  constructor(conversation) {
    this.conversationId = conversation.conversationId;
    this.displayName = conversation.getConversationDisplayName() || conversation.contact.displayName;
    this.text = conversation.newestMessage.body;
    this.lastMessageTime = conversation.newestMessage.originationTime;
    this.number = conversation.newestMessage.from;
    this.contact = conversation.contact;
  }
}
